import styled from 'styled-components'
import { motion } from 'framer-motion'
import Colors from 'utils/Colors'

export default styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;

    svg {
      color: ${(props) => props.theme.palette.primary};
    }
  }

  .text {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 1rem;
    text-align: center;
    color: ${(props) => props.theme.palette.gray[700]};
  }

  .counter {
    font-size: 2rem;
    font-weight: 600;
    color: ${(props) => props.theme.palette.gray[700]};
  }

  .icon {
    svg {
      width: 5rem;
      height: 5rem;
    }

    &.success {
      margin: 2rem 0;
    }

    &.error {
      svg {
        width: 10rem;
        height: 10rem;
        color: ${Colors.red};
        margin: 2.5rem 0 1.5rem 0;
      }
    }

    &.not-finished {
      svg {
        width: 10rem;
        height: 10rem;
        color: #AAAAAA;
        margin-bottom: 2rem;
      }
    }
  }
`
